import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Stream from 'flarum/common/utils/Stream';
import tagIcon from 'flarum/tags/helpers/tagIcon';
import sortTags from 'flarum/tags/utils/sortTags';
import { slug } from '../../common';

const VISIBLE_TAGS_COUNT = 10;

export default class TagNavigation extends Component {
	oninit(vnode) {
		super.oninit(vnode);

		this.tags = sortTags(app.store.all('tags').filter((tag) => !tag.parent()));

		this.showAll = new Stream(false);
	}

	view() {
		/*
		 * Since it's unclear how the tag position is set in gb/core,
		 * 'tag.isChild() == false' is used to avoid showing tags,
		 * which are not top-level tags. If the functional way and
		 * manner is known, then 'tag.position() !== null' may
		 * potentially be used again.
		 */

		let parents = this.tags.filter((tag) => tag.isChild() == false);

		if (!this.showAll()) {
			parents = parents.slice(0, VISIBLE_TAGS_COUNT);
		}

		const shouldAddSlug = app.forum.attribute(`${slug}.add-tag-slug`);

		return (
			<div className='TagNavigation'>
				<div className='TagNavigation-content'>
					<ul className='TagNavigationTiles'>
						{parents.map((tag) => {
							let slug;
							if (shouldAddSlug) {
								slug = tag.slug();
							}

							return this.tagItem(tag, slug);
						})}
					</ul>
				</div>
			</div>
		);
	}

	tagItem(tag, slug) {
		return (
			<li
				className={
					'TagNavigationTile ' +
					((tag.color() ? 'colored' : '') + (slug ? ` ${slug}` : ''))
				}
				style={{ '--tag-bg': tag.color() }}>
				<Link className='TagNavigationTileLink' href={app.route.tag(tag)}>
					<div className='TagNavigationTile-circle'>{tag.icon() && tagIcon(tag, {})}</div>
					<div className='TagNavigationTile-name'>{tag.name()}</div>
				</Link>
			</li>
		);
	}
}
